import { render, staticRenderFns } from "./zonein_zoneout_dispatch_tab.vue?vue&type=template&id=35c5528d"
import script from "./zonein_zoneout_dispatch_tab.vue?vue&type=script&lang=js"
export * from "./zonein_zoneout_dispatch_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports